document.querySelectorAll('[data-deal-timer]').forEach((timer) => {
  const endTime = Number(timer.dataset.dealEnd) * 1000;

  const hoursEl = timer.querySelector('[data-deal-hours]');
  const minutesEl = timer.querySelector('[data-deal-minutes]');
  const secondsEl = timer.querySelector('[data-deal-seconds]');

  const updateTimer = () => {
    const remaining = endTime - Date.now();

    if (remaining <= 0) {
      timer.remove();

      /*
       * The Deal Price shown below the price on the product page is a
       * separate DOM node from the media timer, but belongs to the same
       * single product-level deal, so it is cleared out at the same time.
       */
      document.querySelectorAll('[data-product-deal-price]').forEach((el) => el.remove());
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    hoursEl.textContent = String(hours).padStart(2, '0');
    minutesEl.textContent = String(minutes).padStart(2, '0');
    secondsEl.textContent = String(seconds).padStart(2, '0');
  };

  updateTimer();

  const interval = setInterval(() => {
    if (!document.body.contains(timer)) {
      clearInterval(interval);
      return;
    }

    updateTimer();
  }, 1000);
});

/*
 * Deal of the Day wrapper (product cards).
 * Each [data-deal] element bundles its own timer + Deal Price and is
 * removed as a single unit once its own data-deal-end timestamp passes.
 */
function initDealTimers() {
  document.querySelectorAll('[data-deal]').forEach((deal) => {
    if (deal.dataset.initialized === 'true') {
      return;
    }

    deal.dataset.initialized = 'true';

    const endTime = Number(deal.dataset.dealEnd) * 1000;

    if (!endTime) {
      deal.remove();
      return;
    }

    const updateTimer = () => {
      const remaining = endTime - Date.now();

      if (remaining <= 0) {
        return false;
      }

      const totalSeconds = Math.floor(remaining / 1000);

      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      const hoursElement = deal.querySelector('[data-deal-hours]');
      const minutesElement = deal.querySelector('[data-deal-minutes]');
      const secondsElement = deal.querySelector('[data-deal-seconds]');

      if (hoursElement) {
        hoursElement.textContent = String(hours).padStart(2, '0');
      }

      if (minutesElement) {
        minutesElement.textContent = String(minutes).padStart(2, '0');
      }

      if (secondsElement) {
        secondsElement.textContent = String(seconds).padStart(2, '0');
      }

      return true;
    };

    if (!updateTimer()) {
      deal.remove();
      return;
    }

    const interval = setInterval(() => {
      if (!updateTimer()) {
        clearInterval(interval);

        /*
         * Remove the entire Deal wrapper.
         * This removes both timer and Deal Price.
         */
        deal.remove();
      }
    }, 1000);
  });
}

initDealTimers();

document.addEventListener('shopify:section:load', initDealTimers);

/*
 * The recommended-products section fetches its product markup via XHR
 * after the initial page load (Shopify's dynamic recommendations
 * endpoint) and swaps it into the DOM with innerHTML, well after the
 * initDealTimers() call above already ran. theme.js dispatches this event
 * right after that swap so any [data-deal] cards it injected get started.
 */
document.addEventListener('recommendations:loaded', initDealTimers);

/*
 * Product page (PDP) Deal Price recalculation.
 *
 * The Deal Price shown below the price is rendered server-side from the
 * variant selected at page load. When the shopper picks a different
 * variant/shade, the theme's own variant-change handler already rewrites
 * the regular price in place (see theme.js `updatePrices`), but it has no
 * knowledge of the Deal Price element, so it was left stale. This mirrors
 * that update for [data-deal-price] using the same discount percentage the
 * page rendered into data-deal-discount.
 */
function formatDealMoney(cents) {
  var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
  var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
  var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
  var noDecimals = placeholder.indexOf('no_decimals') !== -1;
  var useCommaDecimal = placeholder.indexOf('comma_separator') !== -1;
  var precision = noDecimals ? 0 : 2;
  var thousands = useCommaDecimal ? '.' : ',';
  var decimal = useCommaDecimal ? ',' : '.';

  var amount = (cents / 100).toFixed(precision);
  var parts = amount.split('.');
  var wholePart = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
  var decimalPart = parts[1] ? decimal + parts[1] : '';
  var formattedAmount = wholePart + decimalPart;

  if (!placeholderMatch) {
    return formattedAmount;
  }

  return format
    .replace(placeholderMatch[0], formattedAmount)
    .replace(new RegExp('\\' + decimal + '00$'), '');
}

document.addEventListener('product:variant-change', (event) => {
  var variant = event.detail && event.detail.variant;

  if (!variant) {
    return;
  }

  document.querySelectorAll('[data-deal-discount]').forEach((dealEl) => {
    var discountPercent = parseFloat(dealEl.dataset.dealDiscount);

    if (!discountPercent) {
      return;
    }

    var priceEl = dealEl.querySelector('[data-deal-price]');

    if (!priceEl) {
      return;
    }

    var dealPriceCents = Math.floor((variant.price * (100 - discountPercent)) / 100);

    priceEl.innerHTML = formatDealMoney(dealPriceCents);
  });
});
